module.exports = __webpack_public_path__ + "img/lg_ring_0_0_1_0@3x.92bc3f05.png";